import { PanelType } from '../../fluent';
import React from 'react';
import { useEffect, useState } from 'react';
import { StandarPanel } from './StandarPanel';
export const StandarDataTableItem = (props) => {
    const [state, setState] = useState({
        model: props.model || {},
        show: props.show || false
    });
    useEffect(() => {
        setState({
            model: props.model || {},
            show: props.show || false
        });
    }, [props]);
    const onChange = (property, value) => {
        props.onChange(Object.assign(Object.assign({}, state.model), { [property]: value }));
    };
    if (!state.show) {
        return React.createElement(React.Fragment, null);
    }
    return React.createElement(StandarPanel, { isOpen: state.show, type: props.panelType || PanelType.medium, headerText: `Item: ${props.title}`, hideAcceptButton: props.readonly, onAccept: () => {
            props.onAccept(state.model);
            props.onClose();
        }, onClose: () => props.onClose(), onRender: () => props.onRender(onChange) });
};
